import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import * as dateFns from 'date-fns';
import { Box, Typography } from '@mui/material';
import { AccessTime } from '@mui/icons-material';

const parseUTC = (dateStr) => {
  const [date, time] = dateStr.split(' ');
  const [year, month, day] = date.split('-').map(Number);
  const [hour, minute, second] = time.split(':').map(Number);

  return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
};

const TheFinalCountdown = ({ time, onExpired }) => {
  const { t } = useTranslation();

  const totalToExpiresInMinutes = 15;

  const startedAtUTC = parseUTC(time);

  const expirationTime = dateFns.addMinutes(startedAtUTC, totalToExpiresInMinutes);

  const calculateTimeLeft = () => {
    const now = new Date(); // NÃO precisa converter

    const totalSecondsRemaining = dateFns.differenceInSeconds(expirationTime, now);

    return {
      minutes: Math.floor(totalSecondsRemaining / 60),
      seconds: totalSecondsRemaining % 60,
      totalSecondsRemaining,
    };
  };

  const hasExpiredCalled = useRef(false);
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      if (newTimeLeft.totalSecondsRemaining <= 0) {
        if (!hasExpiredCalled.current) {
          hasExpiredCalled.current = true;
        }
        clearInterval(timer);
      }
      setTimeLeft(newTimeLeft);
    }, 1000);

    return () => clearInterval(timer);
  }, [expirationTime]);

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        backgroundColor: '#83D84D',
        color: '#000',
        px: 2,
        py: 0.5,
        borderRadius: 5,
        fontWeight: 600,
        mb: 2,
        textAlign: 'center',
      }}
    >
      {timeLeft.totalSecondsRemaining <= 0 ? (
        <Typography variant="body2" sx={{ fontSize: '12px' }}>
          {t('payment.timeIsOver')}
        </Typography>
      ) : (
        <>
          <AccessTime fontSize="small" />
          <span>
            {String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
          </span>
        </>
      )}
    </Box>
  );
};

export default TheFinalCountdown;
